// SPDX-FileCopyrightText: OpenTalk GmbH <mail@opentalk.eu>
//
// SPDX-License-Identifier: EUPL-1.2
import { Paper, styled } from '@mui/material';

export const Container = styled(Paper, {
  shouldForwardProp: (prop) => prop !== 'open',
})<{ open: boolean }>(({ theme, open }) => ({
  display: open ? 'block' : 'none',
  position: 'fixed',
  top: theme.spacing(8),
  right: theme.spacing(2),
  padding: theme.spacing(2, 4),
  zIndex: 8,
  background: theme.palette.background.paper,
  backgroundImage: 'linear-gradient(rgba(255, 255, 255, 0.12), rgba(255, 255, 255, 0.12))',
  boxShadow:
    'rgba(0, 0, 0, 0.2) 0px 5px 5px -3px, rgba(0, 0, 0, 0.14) 0px 8px 10px 1px, rgba(0, 0, 0, 0.12) 0px 3px 14px 2px',
}));
